import { AxiosResponse } from "axios";
import { api } from "../../api";
import { GenericDeleteResponse, StandardResponse } from "../../interfaces/Common";
import { ExamByCodeResponse, PaginatedExamCodeResponse, PartialExamByCodeFormRequest, SortExamByCodeRequest } from "../../interfaces/preboard/Exam";
import { ExamCode, PartialEditExamCodeFormRequest, PartialExamCodeFormRequest } from "../../interfaces/preboard/ExamCode";

export async function getExamCodes(params?: { keyword?: string }): Promise<StandardResponse<PaginatedExamCodeResponse>> {
    const response: AxiosResponse<StandardResponse<PaginatedExamCodeResponse>> = await api.get("/preboard/codes", {
        params
    });
    return response.data;
}

export async function getExamsByCode(examCodeId: string): Promise<StandardResponse<ExamByCodeResponse[]>> {
    const response: AxiosResponse<StandardResponse<ExamByCodeResponse[]>> = await api.get("/preboard/exams", {
        params: {
            examCodeId
        }
    });
    return response.data;
}

export async function createExamCode(request: PartialExamCodeFormRequest): Promise<StandardResponse<ExamCode>> {
    const response: AxiosResponse<StandardResponse<ExamCode>> = await api.post("/preboard/codes", request);
    return response.data;
}

export async function createExamByCode(request: PartialExamByCodeFormRequest): Promise<StandardResponse<ExamByCodeResponse>> {
    const response: AxiosResponse<StandardResponse<ExamByCodeResponse>> = await api.post("/preboard/exams", request);
    return response.data;
}

export async function sortExamByCode(request: SortExamByCodeRequest): Promise<StandardResponse<any>> {
    const response: AxiosResponse<StandardResponse<any>> = await api.post("/preboard/exams/sequence", request);
    return response.data;
}

export async function updateExamCode(examCodeId: string, request: PartialEditExamCodeFormRequest): Promise<StandardResponse<ExamCode>> {
    const response: AxiosResponse<StandardResponse<ExamCode>> = await api.put(`/preboard/codes/${examCodeId}`, request);
    return response.data;
}

export async function updateExamByCode(examId: string, request: PartialEditExamCodeFormRequest): Promise<StandardResponse<ExamByCodeResponse>> {
    const response: AxiosResponse<StandardResponse<ExamByCodeResponse>> = await api.put(`/preboard/exams/${examId}`, request);
    return response.data;
}

export async function deleteExamCode(examCodeId: string): Promise<StandardResponse<GenericDeleteResponse>> {
    const response: AxiosResponse<StandardResponse<GenericDeleteResponse>> = await api.delete(`/preboard/codes/${examCodeId}`);
    return response.data;
}

export async function deleteExamByCode(examId: string): Promise<StandardResponse<GenericDeleteResponse>> {
    const response: AxiosResponse<StandardResponse<GenericDeleteResponse>> = await api.delete(`/preboard/exams/${examId}`);
    return response.data;
}

export async function exportExams(examCodeId: string): Promise<AxiosResponse<Blob>> {
    return await api.get(`/preboard/examinees/codes/${examCodeId}/export`, {
        responseType: 'blob',
    });
}